import React, { ReactNode } from 'react';

import Chevron from '@/components/icons/Chevron.svg';

import css from './index.module.css';

interface IProps {
  icon: ReactNode;
  link: string;
  title: ReactNode;
  description: ReactNode;
}

const SolutionButton: React.FC<IProps> = ({ icon, link, title, description }) => {
  return (
    <a href={link}>
      <div className={css.wrapper}>
        <div className={css.icon}>{icon}</div>
        <div>
          <div className={css.title}>{title}</div>
          <div className={css.description}>{description}</div>
        </div>
        <div className={css.chevron}>
          <Chevron />
        </div>
      </div>
    </a>
  );
};

export default SolutionButton;
